import { createContext, useContext } from "react";
import { CreateCategoryModalContentsProps } from "@kaltura/mediaspace-shared-create-category-modal";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";

export const ChannelsContext = createContext<{
    pageSize: number;
    subscribeUrl?: string;
    unsubscribeUrl?: string;
    allowCreateChannel: boolean;
    createChannelModalProps?: CreateCategoryModalContentsProps;
    searchUrl: string;
    filterBarComponents: KmsTypeComponent[];
}>({
    pageSize: 20,
    subscribeUrl: "",
    unsubscribeUrl: "",
    allowCreateChannel: false,
    searchUrl: "",
    filterBarComponents: [],
});

export const useChannelsContext = () => {
    return useContext(ChannelsContext);
};
